/**
 * MentalAccountingSequence.tsx
 * Last updated: 2025-08-12 14:39:33
 * Updated by: JulianPolly
 */

import './Bee-1.scss'
import { ScreenSequence } from "../Sequences";
import { Screen1 } from "./Screen-1";
import { Screen2 } from "./Screen-2";
import { ResultScreen } from "./ResultScreen";
import { useSession } from "../../../SessionContext";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { ExplainationScreen } from "./ExplanaitionScreen";
import { useLanguage } from "../../../../context/LanguageContext";
import {ResultScreenGlobal} from "./ResultScreenGlobal"; // Import language hook

export const MentalAccountingKey = "MentalAccounting";

// Factory-Funktion für randomisierte Bedingung ("randomizer2")
export function useMentalAccountingSequence(): ScreenSequence {
    const { userData } = useSession();
    const { t } = useLanguage(); // Use language hook for translations

    // Default: "Bedingung 1", falls randomizer2 nicht gesetzt ist
    const randomizer2 = userData?.randomizer2 || "Bedingung 1";

    return {
        name: t('experiments', 'mentalAccounting', 'title'),
        description: t('experiments', 'mentalAccounting', 'description'),
        group: "Info",
        screens: [
            randomizer2 === "Bedingung 2"
                ? Screen2
                : Screen1,
            ResultScreen,
            ResultScreenGlobal,
            ExplainationScreen,
            {
                component: WellDoneScreen,
                canContinueDefault: false,
            }
        ],
        resultScreenIndex: 1,
        explanationScreenIndex: 3,
    };
}